import { z } from 'zod';

export const MessagingChannelAccountStatusDto = z.enum([
  'CONNECTING',
  'ACTIVE',
  'DISABLED',
  'ERROR',
  'REAUTH_REQUIRED',
]);
export type MessagingChannelAccountStatusDto = z.infer<typeof MessagingChannelAccountStatusDto>;

export const CrmInstagramAuthMethodDto = z.enum(['META_BUSINESS', 'INSTAGRAM_LOGIN']);
export type CrmInstagramAuthMethodDto = z.infer<typeof CrmInstagramAuthMethodDto>;

export const CrmInstagramConnectStartBody = z.object({
  label: z.string().trim().min(1).max(120),
  cityIds: z.array(z.uuid()).min(1).max(20),
  /** Способ OAuth: Meta Business (Facebook) или Instagram Login. По умолчанию — Instagram Login. */
  authMethod: CrmInstagramAuthMethodDto.optional(),
  /** Повторная авторизация существующего аккаунта. */
  reconnectAccountId: z.uuid().optional(),
});
export type CrmInstagramConnectStartBody = z.infer<typeof CrmInstagramConnectStartBody>;

export const CrmInstagramConnectStartDto = z.object({
  authorizeUrl: z.url(),
  channelAccountId: z.uuid(),
});
export type CrmInstagramConnectStartDto = z.infer<typeof CrmInstagramConnectStartDto>;

export const CrmInstagramAccountDto = z.object({
  id: z.uuid(),
  label: z.string(),
  externalAccountId: z.string(),
  status: MessagingChannelAccountStatusDto,
  cityIds: z.array(z.uuid()),
  responsibleUserId: z.uuid().nullable(),
  responsibleDisplayName: z.string().min(1).max(120).nullable(),
  username: z.string().nullable(),
  tokenExpiresAt: z.iso.datetime().nullable(),
  statusDetail: z.string().max(500).nullable(),
  authMethod: CrmInstagramAuthMethodDto,
  createdAt: z.iso.datetime(),
});
export type CrmInstagramAccountDto = z.infer<typeof CrmInstagramAccountDto>;

export const CrmInstagramAccountsDto = z.object({
  items: z.array(CrmInstagramAccountDto),
});
export type CrmInstagramAccountsDto = z.infer<typeof CrmInstagramAccountsDto>;

export const CrmInstagramReassignResponsibleBody = z.object({
  responsibleUserId: z.uuid().nullable(),
});
export type CrmInstagramReassignResponsibleBody = z.infer<typeof CrmInstagramReassignResponsibleBody>;
